import React from "react";
import { Navigate } from 'react-router-dom';

const ProtectedRoute = (props) => {
    const isLoggedIn = (window.sessionStorage.getItem('isLoggedIn')) != null ? true : false;
    return isLoggedIn ? props.cmp : <Navigate to="/sign-in" />
}
export default ProtectedRoute;